import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PrestacionesRechazadasAprobadas } from 'app/services/interfaces/prestaciones-service/prestaciones-rechazadas-aprobadas.interface';
import { PrestacionPdfService } from 'app/services/prestacion-pdf.service';
import { LoginService } from 'app/services/login.service';

@Component({
  selector: 'app-grilla-prestaciones-aprobadas-rechazadas',
  templateUrl: './grilla-prestaciones-aprobadas-rechazadas.component.html',
  styleUrls: ['./grilla-prestaciones-aprobadas-rechazadas.component.scss']
})
export class GrillaPrestacionesAprobadasRechazadasComponent implements OnInit {
  @Input() listPrestacionesRechasadasAprobadas: PrestacionesRechazadasAprobadas[] = [];
  columndefs: any = ['Prestacion', 'Prestador', 'Desde', 'Hasta', 'Sesiones', 'Estado', 'Link', 'Descarga'];
  loadingDownload: Set<string> = new Set();

  constructor(private router: Router, private prestacionPdfService: PrestacionPdfService, private getSessionData: LoginService) {}

  ngOnInit(): void {}

  irADetalle(element: PrestacionesRechazadasAprobadas) {
    this.router.navigate([`discapacidad/prestaciones/detalles-prestacion`], {
      queryParams: {
        benNroAse: element.BenNroAse,
        benNroOrden: element.BenNroOrd,
        discaTramSec: element.DiscaTramSec,
        anio: element.Anio
      }
    });
  }

  isLoading(element: PrestacionesRechazadasAprobadas): boolean {
    return this.loadingDownload.has(`${element.BenNroAse}-${element.DiscaTramSec}-${element.Anio}`);
  }

  descargarPdf(element: PrestacionesRechazadasAprobadas) {
  
    const elementKey = `${element.BenNroAse}-${element.DiscaTramSec}-${element.Anio}`;
    this.loadingDownload.add(elementKey);

    this.getSessionData.getSessionData().subscribe(
      (result) => {
        const sessionId = result.session_id;
        this.prestacionPdfService.downloadPrestacionPdf(sessionId, element)
          .subscribe(
            (pdfBlob: Blob) => {
              const filename = `prestacion_${element.BenNroAse}_${element.Prestacion}.pdf`;
              this.prestacionPdfService.triggerDownload(pdfBlob, filename);
              this.loadingDownload.delete(elementKey);
            },
            (error) => {
              console.error('Error descargando PDF:', error);
              this.loadingDownload.delete(elementKey);
            }
          );
      },
      (error) => {
        console.error('Error obteniendo sesión:', error);
        this.loadingDownload.delete(elementKey);
      }
    );
  }
}
